import type {FC} from 'react';
import {Box, Typography} from '@wellstone-solutions/web';
import {headerPalette} from './palette';

interface AttributePillProps {
  label: string;
}

export const AttributePill: FC<AttributePillProps> = ({label}) => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: headerPalette.whisper,
      border: `1px solid ${headerPalette.violetSoft}`,
      borderRadius: 999,
      display: 'inline-flex',
      height: 28,
      paddingX: '13px',
    }}>
    <Typography
      sx={{color: headerPalette.violetDark, fontSize: 13, fontWeight: 500}}>
      {label}
    </Typography>
  </Box>
);
